import React, { ChangeEvent } from 'react';
import { DataTable } from '@/components/shared';
import { List } from '@refinedev/antd';
import { endPoints } from '@/api/configs';
import { useList } from '@/hooks/useList';
import { useTranslation } from '@refinedev/core';
import { ContactsOutlined } from '@ant-design/icons';
import { getColumns } from './columns';
import { Form, Input, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { ContactRes } from '@/api/types/contactUs';

export const ContactUsList = () => {
  const { translate } = useTranslation();
  const [form] = Form.useForm();
  const {
    data,
    isLoading,
    page,
    setPage,
    isRefetching,
    setSearch,
    resolvedTotal,
  } = useList<{
    data: ContactRes[];
  }>({
    endpoint: endPoints.contactUs(),
    filters: {
      status: undefined,
    },
  });

  const columns = getColumns(translate);

  const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setPage(1);
    setSearch(e.target.value);
  };

  const resetFilters = () => {
    setPage(1);
    setSearch('');
  };

  return (
    <List
      title={
        <div className="flex gap-x-3">
          <ContactsOutlined />
          <h1>{translate('listing-contact-us.title')}</h1>
        </div>
      }
    >
      <Form form={form} layout="vertical">
        <div className="flex flex-wrap gap-x-3">
          <Form.Item name="search" className="w-full sm:w-1/6 min-w-[200px]">
            <Input
              placeholder={translate('search-admin.fields.search')}
              onChange={onSearch}
            />
          </Form.Item>
          <Button
            className="mb-2 sm:mb-0"
            type="primary"
            icon={<ReloadOutlined />}
            onClick={resetFilters}
          />
        </div>
      </Form>
      <DataTable
        pageSize={10}
        currentPage={page}
        onPageChange={setPage}
        columns={columns}
        loading={isLoading || isRefetching}
        data={{
          data: data?.data.data || [],
          headers: {
            'x-total-count': resolvedTotal,
          },
        }}
      />
    </List>
  );
};
